import { Component, Input } from '@angular/core';
import { HOME_COPY } from '../data/home-microempresario.content';
import {
  HOME_BANNER_IMAGE_JURIDICA,
  HOME_BANNER_IMAGE_JURIDICA_MOBILE,
  HOME_BANNER_IMAGE_NATURAL,
  HOME_BANNER_IMAGE_NATURAL_MOBILE,
} from '../data/home-banner-images';

/**
 * Banner de bienvenida del home microempresario.
 * Mismos assets PN/PJ del landing.
 * Desktop: imagen en el hero. Mobile: la imagen se muestra tras la tabla (home).
 */
@Component({
  selector: 'app-home-bienvenida-banner',
  templateUrl: './home-bienvenida-banner.component.html',
  styleUrls: ['./home-bienvenida-banner.component.scss'],
  standalone: false,
})
export class HomeBienvenidaBannerComponent {
  readonly copy = HOME_COPY.banner;

  /** Primer nombre (o razón social corta) para el hero. */
  @Input() displayName = '';
  @Input() isJuridica = false;

  get portraitSrc(): string {
    return this.isJuridica ? HOME_BANNER_IMAGE_JURIDICA : HOME_BANNER_IMAGE_NATURAL;
  }

  get portraitSrcMobile(): string {
    return this.isJuridica
      ? HOME_BANNER_IMAGE_JURIDICA_MOBILE
      : HOME_BANNER_IMAGE_NATURAL_MOBILE;
  }
}
